import { Users, Gift, Clock } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

interface EventStatsRowProps {
  confirmedGuests: number;
  totalGifts: number;
  /** null while the event date is not decided yet (JUB-154). */
  daysLeft: number | null;
  currentLocale: string;
}

export function EventStatsRow({
  confirmedGuests,
  totalGifts,
  daysLeft,
}: EventStatsRowProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-3 gap-3">
      {/* GUESTS */}
      <div className="rounded-xl bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-950/30 dark:to-emerald-950/20 p-4 flex flex-col items-center justify-center border border-green-100 dark:border-green-900/30 shadow-sm">
        <div className="p-1.5 rounded-lg bg-green-100 dark:bg-green-900/40 mb-2">
          <Users className="h-4 w-4 text-green-700 dark:text-green-400" />
        </div>
        <div className="text-3xl font-extrabold text-green-700 dark:text-green-400 mb-1">
          {confirmedGuests}
        </div>
        <p className="text-sm text-green-600 dark:text-green-500 text-center">
          {t('events.stats.guestsLabel')}
        </p>
      </div>

      {/* GIFTS */}
      <div className="rounded-xl bg-gradient-to-br from-purple-50 to-violet-50 dark:from-purple-950/30 dark:to-violet-950/20 p-4 flex flex-col items-center justify-center border border-purple-100 dark:border-purple-900/30 shadow-sm">
        <div className="p-1.5 rounded-lg bg-purple-100 dark:bg-purple-900/40 mb-2">
          <Gift className="h-4 w-4 text-purple-700 dark:text-purple-400" />
        </div>
        <div className="text-3xl font-extrabold text-purple-700 dark:text-purple-400 mb-1">
          {totalGifts}
        </div>
        <p className="text-sm text-purple-600 dark:text-purple-500 text-center">
          {t('events.stats.giftsLabel')}
        </p>
      </div>

      {/* DAYS LEFT */}
      <div className="rounded-xl bg-gradient-to-br from-orange-50 to-amber-50 dark:from-orange-950/30 dark:to-amber-950/20 p-4 flex flex-col items-center justify-center border border-orange-100 dark:border-orange-900/30 shadow-sm">
        <div className="p-1.5 rounded-lg bg-orange-100 dark:bg-orange-900/40 mb-2">
          <Clock className="h-4 w-4 text-orange-700 dark:text-orange-400" />
        </div>
        <div className="text-3xl font-extrabold text-orange-700 dark:text-orange-400 mb-1">
          {daysLeft === null ? '—' : daysLeft > 0 ? daysLeft : 0}
        </div>
        <p className="text-sm text-orange-600 dark:text-orange-500 text-center">
          {t('events.stats.daysUntil') || t('events.stats.daysLeft')}
        </p>
      </div>
    </div>
  );
}

